import Vue from 'vue'
let moment = require('moment')

Vue.filter('formatDateDayMonth', function (value) {
  return (value !== '0') ? moment(value, 'YYYY-MM-DD').format('dddd, D MMMM') : 'Not day specific'
})

Vue.filter('formatDateDayMonthShort', function (value) {
  return (value !== '0') ? moment(value, 'YYYY-MM-DD').format('ddd, DD MMM') : 'Not day specific'
})

Vue.filter('formatDateShort', function (value) {
  return (value !== '0') ? moment(value, 'YYYY-MM-DD').format('DD MMM') : ''
})

Vue.filter('formatFullDateShort', function (value) {
  return (value !== '0') ? moment(value, 'YYYY-MM-DD').format('DD MMM YYYY') : ''
})

Vue.filter('formatDateDayMonthCalendar', function (value) {
  return (value !== '0') ? (moment(value, 'YYYY-MM-DD').calendar().split(' at'))[0] : ''
})

Vue.filter('formatDateSubscription', function (value) {
  return (value !== '0') ? moment(value, 'YYYY-MM-DD HH:mm:ss Z').format('dddd, DD MMM YYYY') : ''
})
